import React, { useEffect, useMemo, useState } from "react";
import logo_2 from "../../assets/img/logo/logo2.png";
import { Link, useLocation } from "react-router-dom";
import "./HeaderSales.css";

const STATIC_CONTACTS = {
  email: "Info@cerastarplumber.com",
  hours: "Mon-Fri 09.30 AM - 5.30PM",
  phone: "18002026182",
};

export default function HeaderSales() {
  const location = useLocation();
  const userType = localStorage.getItem("user_type");
  const userName = localStorage.getItem("user_name") || "User";
  const brand = localStorage.getItem("brand");
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportMenuOpen, setReportMenuOpen] = useState(false);
  const [desktopReportHoverOpen, setDesktopReportHoverOpen] = useState(false);

  const logout = () => {
    localStorage.clear();
  };

  const dashboardTabs = [
    { label: "Dashboard", to: "/sales_dashboard" },
    { label: "Pending for approval", to: "/pending_for_approval" },
    { label: "Approved Plumbers", to: "/approved_plumber" },
    { label: "Rejected Plumbers", to: "/rejected_plumber" },
    ...(userType === "HO" || userType === "RO" || userType === "SH"
      ? []
      : [{ label: "Plumbers", to: "/add_new_plumber" }]),
  ];

  const reportLinks = useMemo(
    () => [
      { label: "Enrollment Report", to: "/new_enrollment_report" },
      ...(userType === "HO"
        ? [
          { label: "Polipluz QR Transaction Report", to: "/Qr_Trans_Report_New_Polipluz" },
          { label: "CERA QR Transaction report", to: "/sales_qr_transaction_new_report" },
        ]
        : brand === "POLIPLUZ"
          ? [{ label: "Polipluz QR Transaction Report", to: "/Qr_Trans_Report_New_Polipluz" }]
          : [{ label: "CERA QR Transaction report", to: "/sales_qr_transaction_new_report" }]),
      { label: "Error QR Transaction Report", to: "/new_sales_error_qr_transaction_report" },
      { label: "Top Performers Report", to: "/sales_top_performance_report" },
      // { label: "OLD Redemption Report", to: "/sales_redemption_report" },
      { label: "Redeemption Report", to: "/new_sales_redemption_report" },
      { label: "Ticket Report", to: "/new_sales_ticket_report" },
    ],
    [brand, userType]
  );

  const approvalRoutes = ["/pending_for_approval", "/approved_plumber", "/rejected_plumber"];
  const reportRoutes = useMemo(() => reportLinks.map((item) => item.to), [reportLinks]);

  useEffect(() => {
    setMenuOpen(false);
    setReportMenuOpen(false);
    setDesktopReportHoverOpen(false);
  }, [location.pathname]);

  const isMobileViewport = () => window.innerWidth <= 991;

  const handleReportButtonClick = () => {
    if (isMobileViewport()) {
      setReportMenuOpen((prev) => !prev);
    }
  };

  const handleReportMouseEnter = () => {
    if (!isMobileViewport()) {
      setDesktopReportHoverOpen(true);
    }
  };

  const handleReportMouseLeave = () => {
    if (!isMobileViewport()) {
      setDesktopReportHoverOpen(false);
    }
  };

  const isReportMenuVisible = desktopReportHoverOpen || reportMenuOpen;

  const isTabActive = (label, to) => {
    if (label === "Dashboard" || label === "Performance") {
      return location.pathname === "/sales_dashboard";
    }

    if (label === "Approvals") {
      return approvalRoutes.includes(location.pathname);
    }

    if (label === "Plumbers") {
      return location.pathname === to;
    }

    return location.pathname === to;
  };

  return (
    <header className="dashboard-header-mock">
      <div className="dashboard-header-mock-inner">
        <div className="dashboard-header-mock-topbar">
          <Link to="/sales_dashboard" className="dashboard-header-mock-logo">
            <img src={logo_2} alt="Cera StarPlumber" />
          </Link>

          <button
            type="button"
            className={`dashboard-header-mock-hamburger ${menuOpen ? "is-open" : ""}`}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`dashboard-header-mock-nav ${menuOpen ? "is-open" : ""}`}>
            {dashboardTabs.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className={`dashboard-header-mock-tab ${isTabActive(item.label, item.to) ? "is-active" : ""}`}
              >
                {item.label}
              </Link>
            ))}

            <div
              className="dashboard-header-mock-report-wrap"
              onMouseEnter={handleReportMouseEnter}
              onMouseLeave={handleReportMouseLeave}
            >
              <button
                type="button"
                className={`dashboard-header-mock-tab dashboard-header-mock-report-btn ${reportRoutes.includes(location.pathname) ? "is-active" : ""
                  }`}
                aria-expanded={isReportMenuVisible}
                onClick={handleReportButtonClick}
              >
                Reports
                <i className={`fa fa-angle-down dashboard-header-mock-report-caret ${isReportMenuVisible ? "is-open" : ""}`} />
              </button>
              <div className={`dashboard-header-mock-report-menu ${isReportMenuVisible ? "is-open" : ""}`}>
                {reportLinks.map((item) => (
                  <Link key={item.to} to={item.to}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>

          {userName}
          <div className="dashboard-header-mock-icons">
            {/* <button type="button" aria-label="" style={{ width: "auto", height: "auto" }}>
              {userName}
            </button> */}
            <Link to="/" aria-label="Logout" onClick={logout}>
              <i className="fa fa-sign-out" />
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

